export default {
    BASE_URL: 'crm/stats/',
    api: [
        {
            name: 'projList',
            desc: '统计分析项目列表',
            method: 'GET',
            path: '/pub/selectProjectList'
        },
        {
            name: 'teamList',
            desc: '统计分析班组列表',
            method: 'GET',
            path: '/pub/selectTeamList'
        },
        {
            name: 'joinAndQuitData',
            desc: '入场退场趋势数据统计',
            method: 'GET',
            path: 'selectJoinOutBuilder'
        },
        {
            name: 'recordAmountsData',
            desc: '记工费用趋势数据统计',
            method: 'GET',
            path: 'record/amounts'
        },
        {
            name: 'recordsData',
            desc: '记工变化趋势数据统计',
            method: 'GET',
            path: '/selectChangingTrend'
        },
        {
            name: 'mapData',
            desc: '基本信息统计地域地图数据',
            method: 'GET',
            path: '/selectBuilderProvince'
        },
        {
            name: 'sexData',
            desc: '基本信息统计性别比例',
            method: 'GET',
            path: '/selectBuildersex'
        },
        {
            name: 'ageData',
            desc: '基本信息统计年龄分布',
            method: 'GET',
            path: '/selectBuilderAge'
        },
    ]
}


// WEBPACK FOOTER //
// ./src/api/statistics/stats.js